import store from '../index'

export const dispatchFinishInitialLoad = () => {
  store.dispatch({ type: 'FINISH_INITIAL_LOAD' })
}
